import { render, staticRenderFns } from "./PaginaSeleccionMuniPeriodoAprobacion.vue?vue&type=template&id=23080bed&lang=true"
import script from "./PaginaSeleccionMuniPeriodoAprobacion.vue?vue&type=script&lang=js"
export * from "./PaginaSeleccionMuniPeriodoAprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports